import { ArrowRight, Crown } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";
import { PREMIUM_ANNUAL_DISPLAY } from "@/utils/publicPrices";

interface UpgradePlanCardProps {
  onUpgradeSuccess: () => void;
}

export function UpgradePlanCard({ onUpgradeSuccess }: UpgradePlanCardProps) {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleUpgrade = async () => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('create-premium-checkout');

      if (error) {
        throw new Error(error.message);
      }

      if (data.url) {
        window.location.href = data.url;
      } else {
        throw new Error("URL de checkout não encontrada.");
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Erro ao iniciar upgrade",
        description: error instanceof Error ? error.message : "Tente novamente mais tarde.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="bg-purple-50 border-purple-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-purple-800">
          <Crown className="h-5 w-5" />
          Faça Upgrade para Premium
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-purple-700">
          Desbloqueie todos os recursos e escreva cartas ilimitadas com o plano Premium por {PREMIUM_ANNUAL_DISPLAY}.
        </p>
        <ul className="text-sm text-purple-600 space-y-1 list-disc list-inside">
          <li>Cartas ilimitadas</li>
          <li>Entrega por WhatsApp</li>
          <li>Edite cartas agendadas</li>
          <li>Suporte prioritário</li>
        </ul>
        <Button 
          onClick={handleUpgrade} 
          disabled={isLoading}
          className="w-full bg-purple-600 hover:bg-purple-700"
        >
          {isLoading ? "Aguarde..." : "Fazer Upgrade Agora"}
          <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </CardContent>
    </Card>
  );
}